import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import TenantActions from '@Actions/tenantActions';
import ZohoIntegrationActions from '@Actions/integrations/zohoIntegrationActions';
import {
  Table, Select, notification, Popconfirm,
} from 'antd';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import {
  DeleteOutlined, PlusCircleFilled,
} from '@ant-design/icons';
import { v4 as uuidv4 } from 'uuid';
import PRZSelect from '../../../../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
const ZohoMapLocations = ({
  user, getTenants, getTenantsLoading, tenants, getZohoConnections, zohoConnections, connectTenantToLocation, connectTenantToLocationLoading, setStep, getZohoConnectionsLoading, pullProducts, pullProductsLoading, pullVendors, pullVendorsLoading, pullCustomers, pullCustomersLoading,
}) => {
  const [tenantData, setTenantData] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [formSubmitted, setFormSubmitted] = useState('');

  useEffect(() => {
    getTenants(1, '', true, user?.tenant_info?.org_id);
    getZohoConnections(user?.tenant_info?.org_id);
  }, []);

  useEffect(() => {
    const copyTenantData = tenants?.data?.filter((item) => item?.zoho_branch_id)?.map((tenant) => ({ ...tenant, zoho_branch_id: tenant?.zoho_branch_id, key: uuidv4() }));
    setTenantData(copyTenantData);
  }, [tenants]);

  const updateTableValue = (key, value, label) => {
    const data = tenantData.map((tenant) => {
      if (tenant.key === key) {
        // eslint-disable-next-line no-param-reassign
        tenant[label] = value;
        return tenant;
      }
      return tenant;
    });
    setTenantData(data);
  };

  const getSelectedTenant = (record) => tenantData?.filter((item) => !item?.is_deleted).filter((item) => item?.tenant_id !== record?.tenant_id).map((tenant) => tenant.tenant_id);

  const getDataSource = (data) => (data ? JSON.parse(JSON.stringify(data?.filter((tenant) => !tenant.is_deleted))) : []);

  const addNewRow = () => {
    if (tenantData?.length) {
      setTenantData([...tenantData, { key: uuidv4() }]);
    } else {
      setTenantData([{}]);
    }
  };

  const removeRow = (key) => {
    if (tenantData?.filter((tenant) => !tenant.is_deleted)?.length === 1) {
      const newTenantData = tenantData?.map((tenant) => {
        if (tenant?.key === key) {
          return { ...tenant, is_deleted: true };
        }

        return { ...tenant };
      });
      setTenantData([...newTenantData, { key: uuidv4() }]);
    } else {
      const newTenantData = tenantData?.map((tenant) => {
        if (tenant?.key === key) {
          return { ...tenant, is_deleted: true };
        }

        return { ...tenant };
      });

      setTenantData(newTenantData);
    }
  };

  const columns = [
    {
      title: 'Business Unit Name',
      width: '312px',
      render: (record) => (
        <div>
          <PRZSelect
            value={record?.tenant_id}
            showSearch
            filterOption={false}
            onChange={(value) => {
              const orgId = tenants?.[0]?.org_id;
              updateTableValue(record?.key, value, 'tenant_id');
              updateTableValue(record?.key, orgId, 'org_id');
              setSearchKeyword('');
            }}
            placeholder="Select Business Unit"
            style={{
              border: !(formSubmitted && !record?.tenant_id) ? '1px solid rgba(68, 130, 218, 0.2)' : '1px solid red',
              marginRight: '10px',
            }}
            onSearch={(value) => {
              setSearchKeyword(value);
            }}
            disabled={connectTenantToLocationLoading}
          >
            {tenants?.data
              ?.filter((item) => !getSelectedTenant(record)?.includes(item?.tenant_id))
              ?.filter((item) => (searchKeyword ? item?.tenant_name?.toUpperCase()?.includes(searchKeyword?.toUpperCase()) : true))
              .map(
                (item) => <Option key={item?.tenant_id} value={item?.tenant_id}>{item?.tenant_name}</Option>,
              )}
          </PRZSelect>
        </div>
      ),
    },
    {
      title: 'Location',
      width: '275px',
      render: (record) => (
        <div>
          <PRZSelect
            value={record.zoho_branch_id}
            filterOption={false}
            onChange={(value) => {
              updateTableValue(record?.key, value, 'zoho_branch_id');
            }}
            placeholder="Select a location"
            dropdownAlign={{ offset: [-6, 4] }}
            style={{
              border: !(formSubmitted && !record?.zoho_branch_id) ? '1px solid rgba(68, 130, 218, 0.2)' : '1px solid red',
              marginRight: '10px',
            }}
            disabled={connectTenantToLocationLoading}
          >
            {zohoConnections && zohoConnections?.filter((connection) => connection?.is_active)?.[0]?.branches
              .map((item) => (

                <Option key={item.branch_id} value={item.branch_id}>
                  {`${item?.branch_name}`}
                </Option>
              ))}
          </PRZSelect>
        </div>
      ),
    },
    {
      title: '',
      render: (record) => (
        <div>
          {!record?.zoho_facility_codes?.length ? (
            <div style={{ display: 'flex', alignItems: 'baseline' }}>
              <Popconfirm
                placement="topRight"
                title="Are you sure you want to delete this line?"
                onConfirm={() => removeRow(record?.key)}
                okText="Yes"
                cancelText="No"
              >
                <div className="deleteButton">
                  {' '}
                  <DeleteOutlined />
                  {' '}
                </div>
              </Popconfirm>
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'baseline' }}>
              {' '}
              <Popconfirm
                placement="topRight"
                title="Are you sure you want to delete this line?"
                onConfirm={() => removeRow(record?.key)}
                okText="Yes"
                cancelText="No"
              >
                <div className="deleteButton">
                  {' '}
                  <DeleteOutlined />
                  {' '}
                </div>
              </Popconfirm>

            </div>

          )}

        </div>
      ),

    },
  ];

  const isDataValid = (data) => {
    const copyData = data?.filter((item) => !item?.is_deleted);
    for (let i = 0; i < copyData?.length; i++) {
      if (!data[i]?.tenant_id || !data[i]?.zoho_branch_id) {
        return false;
      }
    }
    return true;
  };

  const handleSubmit = () => {
    setFormSubmitted(true);
    if (isDataValid(tenantData) && tenantData?.filter((item) => !item?.is_deleted && item?.tenant_id && item?.zoho_branch_id).length > 0) {
      const payload = tenantData?.filter((t) => t?.tenant_id)?.map((tenant) => (
        {
          tenant_id: tenant.tenant_id,
          zoho_branch_id: tenant?.is_deleted ? null : tenant.zoho_branch_id,
          org_id: user?.tenant_info?.org_id,
        }
      ));
      connectTenantToLocation(payload, () => setStep(2));
    } else {
      notification.error({
        message: 'Please select location for every tenant',
        placement: 'top',
        duration: 4,
      });
    }
  };

  return (
    <Fragment>
      {(getTenantsLoading || getZohoConnectionsLoading)
        ? (
          <div className="zoho-integration__loader__wrapper">

            {[...Array(5).keys()].map((item) => (
              <div key={item} className="zoho-integration__loader-row">
                <div className="loadingBlock  zoho-integration__loader__line1" />
                <div className="loadingBlock  zoho-integration__loader__line2" />
                <div className="loadingBlock  zoho-integration__loader__line3" />
              </div>
            ))}
            <div className="loadingBlock zoho-integration__loader__line-btn1" />
            <div className="loadingBlock zoho-integration__loader__line-btn2" />
          </div>
        )
        : (
          <div className="zoho__location-wrapper">
            <div className="ant-row">
              <div className="ant-col-md-18">
                <Table
                  columns={columns}
                  loading={getTenantsLoading || getZohoConnectionsLoading || connectTenantToLocationLoading || pullVendorsLoading || pullProductsLoading}
                  dataSource={getDataSource(tenantData) || []}
                  size="small"
                  pagination={false}
                />
              </div>
            </div>
            <div className="new-row-button" style={{ marginLeft: '10px' }} onClick={() => addNewRow()}>
              <span className="new-row-button__icon"><PlusCircleFilled /></span>
              <div>New Item</div>
            </div>
            <div className="ant-row">
              &nbsp;&nbsp;
              <H3Button
                text="Connect Account"
                buttonType={defaultButtonTypes.BLUE_ROUNDED}
                onClick={() => handleSubmit()}
                customClass="zoho__location-submit"
                isLoading={connectTenantToLocationLoading || pullVendorsLoading || pullProductsLoading || pullCustomersLoading}
                disabled={connectTenantToLocationLoading || pullVendorsLoading || pullProductsLoading || pullCustomersLoading}
              />
            </div>
          </div>
        )}
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, TenantReducers, ZohoIntegrationReducers }) => ({
  user: UserReducers.user,
  tenants: TenantReducers.tenants,
  zohoConnections: ZohoIntegrationReducers.zohoConnections,
  connectTenantToLocationLoading: ZohoIntegrationReducers.connectTenantToLocationLoading,
  pullProductsLoading: ZohoIntegrationReducers.pullProductsLoading,
  pullVendorsLoading: ZohoIntegrationReducers.pullVendorsLoading,
  pullCustomersLoading: ZohoIntegrationReducers.pullCustomersLoading,
  getTenantsLoading: TenantReducers.getTenantsLoading,
});
const mapDispatchToProps = (dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId) => dispatch(
    TenantActions.getTenants(page, keyword, isVerified, orgId),
  ),
  getZohoConnections: (orgId, callback) => dispatch(ZohoIntegrationActions.getZohoConnections(orgId, callback)),
  connectTenantToLocation: (payload, callback) => dispatch(ZohoIntegrationActions.connectTenantToLocation(payload, callback)),
  pullProducts: (payload, callback) => dispatch(ZohoIntegrationActions.pullProducts(payload, callback)),
  pullVendors: (payload, callback) => dispatch(ZohoIntegrationActions.pullVendors(payload, callback)),
  pullCustomers: (payload, callback) => dispatch(ZohoIntegrationActions.pullCustomers(payload, callback)),
});

ZohoMapLocations.propTypes = {
  user: PropTypes.any,
  getTenants: PropTypes.func,
  getZohoConnectionsLoading: PropTypes.bool,
  getTenantsLoading: PropTypes.bool,
  tenants: PropTypes.any,
  getZohoConnections: PropTypes.func,
  connectTenantToLocation: PropTypes.func,
  connectTenantToLocationLoading: PropTypes.bool,
  zohoConnections: PropTypes.any,
  setStep: PropTypes.func,
  pullProducts: PropTypes.func,
  pullProductsLoading: PropTypes.bool,
  pullVendors: PropTypes.func,
  pullVendorsLoading: PropTypes.bool,
  pullCustomers: PropTypes.func,
  pullCustomersLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ZohoMapLocations));
